export const moreContextItems = [
  {
    key: 'marketing-settings',
    icon: '',
    text: 'Marketing settings',
  },
];
